import { SelectChoices } from '../components';
import PersonAutocomplete from '../components/PersonAutocomplete';
import ScaleStatements from '../components/ScaleStatements';
import { GetMessagesQuery } from '../generated/hooks';

interface IProps {
  data?: { messages?: GetMessagesQuery['messages'] };
  values: number[];
  scrollToBottom: () => void;
  disabled?: boolean;
}

const Specials = ({ data, values, disabled, scrollToBottom }: IProps) => {
  const messages = data && data.messages;
  const message = messages && messages[messages.length - 1];

  if (message && 'definition' in message) {
    const definition = message.definition;

    switch (definition.__typename) {
      case 'PersonMultiselectQuestionDefinition':
        return (
          <PersonAutocomplete
            items={definition.organizationRespondents}
            disabled={disabled}
            scrollToBottom={scrollToBottom}
          />
        );
      case 'SelectQuestionDefinition': {
        if (values.length < definition.selectedRange[1]) {
          return (
            <SelectChoices choices={definition.choices} selectedRange={definition.selectedRange} disabled={disabled} />
          );
        }
        return null;
      }
      case 'ScaleQuestionDefinition': {
        if (!definition.statements || !definition.choices) {
          return null;
        }
        return (
          <ScaleStatements
            statements={definition.statements}
            choices={definition.choices}
            randomizeOrder={definition.randomizeOrder}
            isRankingScale={definition.isRankingScale}
            showEscapeOption={definition.showEscapeOption ?? true}
            seedKey={message.id}
            disabled={disabled}
          />
        );
      }
      default:
        return null;
    }
  }
  return null;
};

export default Specials;
